"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.except = void 0;
const effect_1 = require("effect");
const except = (items) => (excludedItems) => effect_1.Array.difference(items, excludedItems);
exports.except = except;
//# sourceMappingURL=array.js.map